module.exports = __webpack_public_path__ + "static/media/btnGoogle.3057db12.png";